module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};



//////////////////
// WEBPACK FOOTER
// /tmp/node_modules/core-js/modules/_perform.js
// module id = 608
// module chunks = 0 1 2 6